/* SoftenFX storefront JS — cart drawer, product form, subscriptions, ritual, bundles */
(function () {
  'use strict';
  var T = window.MD || {};
  var root = (T.routes && T.routes.root) || '/';
  var routes = Object.assign({ cart: root + 'cart', cartJs: root + 'cart.js', add: root + 'cart/add.js', change: root + 'cart/change.js' }, T.routes || {});

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function d(n, p, t, s) { var x = (n / 100).toFixed(p).split('.'); return x[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (x[1] ? s + x[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return d(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return d(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return d(cents, 0, '.', ',');
        default: return d(cents, 2, ',', '.');
      }
    });
  }
  T.money = money;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function toast(msg) { var t = $('#md-toast'); if (!t) return; t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600); }
  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b || b.closest('.line')) return;
    var input = b.parentElement.querySelector('input');
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- mobile menu ---------- */
  var mt = $('[data-menu-toggle]');
  if (mt) mt.addEventListener('click', function () { var n = $('[data-mobile-nav]'); var o = n.classList.toggle('is-open'); mt.setAttribute('aria-expanded', o); });

  /* ======================================================
     CART DRAWER
     ====================================================== */
  var Drawer = {
    el: null, cart: null,
    init: function () {
      this.el = $('#CartDrawer'); if (!this.el) return;
      var self = this;
      $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); self.open(); }); });
      $$('[data-cart-close]').forEach(function (a) { a.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      this.el.addEventListener('click', function (e) {
        var step = e.target.closest('[data-line-step]');
        if (step) { var l = step.closest('.line'); var q = parseInt(l.getAttribute('data-qty'), 10) + parseInt(step.getAttribute('data-line-step'), 10); self.change(l.getAttribute('data-key'), Math.max(0, q)); }
        var rm = e.target.closest('[data-line-remove]');
        if (rm) self.change(rm.closest('.line').getAttribute('data-key'), 0);
        var up = e.target.closest('[data-upsell-add]');
        if (up) { up.classList.add('is-loading'); Cart.add([{ id: Number(up.getAttribute('data-upsell-add')), quantity: 1 }]).finally(function () { up.classList.remove('is-loading'); }); }
      });
      this.refresh();
    },
    open: function () { document.body.classList.add('drawer-open'); this.el.setAttribute('aria-hidden', 'false'); var c = this.el.querySelector('[data-cart-close]'); if (c) c.focus({ preventScroll: true }); },
    close: function () { document.body.classList.remove('drawer-open'); this.el.setAttribute('aria-hidden', 'true'); },
    refresh: function () { var self = this; return json(routes.cartJs).then(function (c) { self.render(c); return c; }); },
    change: function (key, qty) {
      var self = this; this.el.classList.add('is-busy');
      return json(routes.change, { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (c) { self.render(c); })
        .catch(function (err) { toast((err && err.description) || 'Could not update cart'); })
        .finally(function () { self.el.classList.remove('is-busy'); });
    },
    render: function (cart) {
      this.cart = cart;
      $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.setAttribute('data-count', cart.item_count); });
      var th = Number(T.freeShippingThreshold || 0) * 100;
      var ship = $('[data-ship]', this.el);
      if (ship) {
        if (th > 0) {
          var left = th - cart.total_price, pct = Math.min(100, (cart.total_price / th) * 100);
          ship.querySelector('p').innerHTML = left > 0 ? 'You’re <b>' + money(left) + '</b> away from <b>free shipping</b>' : '🎉 You’ve unlocked <b>free shipping!</b>';
          ship.querySelector('.bar i').style.width = pct + '%';
          ship.querySelector('.bar').classList.toggle('is-full', left <= 0);
          ship.hidden = false;
        } else ship.hidden = true;
      }
      var body = $('[data-cart-body]', this.el), foot = $('[data-cart-foot]', this.el);
      var html = '';
      if (!cart.items.length) {
        html = '<div class="drawer__empty"><h4>Your cart is empty</h4><p>Smooth, soft skin is one click away.</p><a class="btn btn--primary" href="' + (T.routes.all || '/collections/all') + '">Shop the collection</a></div>';
      } else {
        cart.items.forEach(function (it) {
          var sub = it.selling_plan_allocation ? '<span class="line__sub">↻ ' + esc(it.selling_plan_allocation.selling_plan.name) + '</span>' : '';
          var v = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="line__v">' + esc(it.variant_title) + '</div>' : '<div class="line__v"></div>';
          var was = it.original_line_price > it.final_line_price ? ' <s>' + money(it.original_line_price) + '</s>' : '';
          html += '<div class="line" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
            '<a href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 180)) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="76" height="76"></a>' +
            '<div><a class="line__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + v + sub +
            '<div class="qty qty--sm"><button type="button" data-line-step="-1" aria-label="Decrease">−</button><input type="number" value="' + it.quantity + '" readonly aria-label="Quantity"><button type="button" data-line-step="1" aria-label="Increase">+</button></div></div>' +
            '<div class="line__r"><span class="price">' + money(it.final_line_price) + was + '</span><button class="line__rm" type="button" data-line-remove>Remove</button></div></div>';
        });
      }
      // Upsell (Roll-On) — hidden once it's already in the cart
      var up = T.upsell;
      if (up && up.variantId && cart.items.length && !cart.items.some(function (i) { return i.product_id === up.productId; })) {
        html += '<div class="upsell"><img src="' + esc(up.image) + '" alt="" width="62" height="62"><div class="upsell__t"><small>' + esc(up.kicker || 'Pairs perfectly') + '</small><b>' + esc(up.title) + '</b><span>' + money(up.price) + (up.compare > up.price ? ' <s>' + money(up.compare) + '</s>' : '') + '</span></div><button class="btn btn--primary btn--sm" type="button" data-upsell-add="' + up.variantId + '">+ Add</button></div>';
      }
      body.innerHTML = html;
      foot.hidden = !cart.items.length;
      var st = $('[data-cart-subtotal]', this.el); if (st) st.textContent = money(cart.total_price);
      var disc = $('[data-cart-discount]', this.el);
      if (disc) { var d = cart.total_discount || 0; disc.hidden = !d; if (d) disc.querySelector('span:last-child').textContent = '−' + money(d); }
    }
  };

  var Cart = {
    add: function (items) {
      return json(routes.add, { method: 'POST', body: JSON.stringify({ items: items }) })
        .then(function () { return Drawer.refresh(); })
        .then(function (c) { Drawer.open(); return c; })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart'); throw err; });
    }
  };
  T.cart = Cart; T.drawer = Drawer;

  /* ======================================================
     PRODUCT FORM (purchase options, subscribe & save)
     ====================================================== */
  function initProduct(sec) {
    var form = $('form[data-product-form]', sec); if (!form) return;
    var data = JSON.parse($('[data-product-json]', sec).textContent);
    var idInput = $('input[name="id"]', form), planInput = $('input[name="selling_plan"]', form);
    var qtyInput = $('input[name="quantity"]', form);
    var variant = data.variants.find(function (v) { return v.id == idInput.value; }) || data.variants[0];

    function planFor(v, planId) { return (v.selling_plan_allocations || []).find(function (a) { return a.selling_plan_id == planId; }); }
    function currentPlan() { var c = $('input[name="md-purchase"]:checked', form); if (!c || c.value !== 'subscribe') return null; var f = $('input[name="md-frequency"]:checked', form); return f ? f.value : null; }
    function update() {
      var plan = currentPlan();
      planInput.value = plan || ''; planInput.disabled = !plan;
      $$('.opt', form).forEach(function (o) { o.classList.toggle('is-on', o.querySelector('input[type=radio]').checked); });
      var one = variant.price, subAlloc = plan ? planFor(variant, plan) : null;
      var anyPlan = $('input[name="md-frequency"]', form) ? planFor(variant, $('input[name="md-frequency"]', form).value) : null;
      var subPrice = subAlloc ? subAlloc.price : (anyPlan ? anyPlan.price : Math.round(one * 0.85));
      $$('[data-price-onetime]', sec).forEach(function (n) { n.textContent = money(one); });
      $$('[data-price-sub]', sec).forEach(function (n) { n.textContent = money(subPrice); });
      $$('[data-price-current]', sec).forEach(function (n) { n.textContent = money(plan ? subPrice : one); });
      var cmp = $('[data-price-compare]', sec);
      if (cmp) { var c = plan ? one : (variant.compare_at_price > one ? variant.compare_at_price : 0); cmp.textContent = c ? money(c) : ''; }
      var save = $('[data-price-save]', sec);
      if (save) save.hidden = !plan;
      var btn = $('[data-atc]', form);
      if (btn) { btn.disabled = !variant.available; $('[data-atc-label]', btn).textContent = !variant.available ? 'Sold out' : (plan ? 'Subscribe & save' : 'Add to cart'); }
      var sbtn = $('[data-sticky-label]'); if (sbtn) sbtn.textContent = (plan ? 'Subscribe · ' + money(subPrice) : 'Add to cart · ' + money(one));
      updateRitual(sec);
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('select[data-variant-select]')) {
        variant = data.variants.find(function (v) { return v.id == e.target.value; }) || variant;
        idInput.value = variant.id;
        if (variant.featured_media) showSlide(sec, variant.featured_media.id);
        var url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
      }
      if (e.target.name === 'md-frequency') { var s = $('input[name="md-purchase"][value="subscribe"]', form); if (s) s.checked = true; }
      update();
    });
    $$('.opt', form).forEach(function (o) { o.addEventListener('click', function (e) { if (e.target.closest('.freq')) { o.querySelector('input[type=radio]').checked = true; update(); } }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-atc]', form); btn.classList.add('is-loading');
      var item = { id: Number(idInput.value), quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) };
      if (!planInput.disabled && planInput.value) item.selling_plan = Number(planInput.value);
      Cart.add([item]).catch(function () {}).finally(function () { btn.classList.remove('is-loading'); });
    });
    sec._getMainItem = function () { var it = { id: Number(idInput.value), quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1), price: variant.price }; var p = currentPlan(); if (p) { it.selling_plan = Number(p); var a = planFor(variant, p); if (a) it.price = a.price; } return it; };
    initGallery(sec); initRitual(sec); initSticky(sec, form); update();
  }

  /* ---------- gallery ---------- */
  function showSlide(sec, mediaId) {
    var slides = $$('[data-slide]', sec); var idx = slides.findIndex(function (s) { return s.getAttribute('data-slide') == mediaId; });
    if (idx > -1) goSlide(sec, idx);
  }
  function goSlide(sec, i) {
    var slides = $$('[data-slide]', sec), thumbs = $$('[data-thumb]', sec); if (!slides.length) return;
    i = (i + slides.length) % slides.length; sec._slide = i;
    slides.forEach(function (s, k) { s.hidden = k !== i; });
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i); });
  }
  function initGallery(sec) {
    sec._slide = Math.max(0, $$('[data-slide]', sec).findIndex(function (s) { return !s.hidden; }));
    $$('[data-thumb]', sec).forEach(function (t, k) { t.addEventListener('click', function () { goSlide(sec, k); }); });
    var p = $('[data-gallery-prev]', sec), n = $('[data-gallery-next]', sec);
    if (p) p.addEventListener('click', function () { goSlide(sec, sec._slide - 1); });
    if (n) n.addEventListener('click', function () { goSlide(sec, sec._slide + 1); });
    var main = $('.gallery__main', sec), x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) goSlide(sec, sec._slide + (dx < 0 ? 1 : -1)); x0 = null; });
    }
  }

  /* ---------- complete the ritual ---------- */
  function updateRitual(sec) {
    var box = $('[data-ritual]', sec); if (!box || !sec._getMainItem) return;
    var main = sec._getMainItem(), total = main.price * main.quantity, n = main.quantity;
    $$('input[data-ritual-item]:checked', box).forEach(function (c) { total += Number(c.getAttribute('data-price')); n += 1; });
    $('[data-ritual-total]', box).textContent = money(total);
    $('[data-ritual-count]', box).textContent = n;
  }
  function initRitual(sec) {
    var box = $('[data-ritual]', sec); if (!box) return;
    box.addEventListener('change', function () { updateRitual(sec); });
    $('[data-ritual-add]', box).addEventListener('click', function (e) {
      var btn = e.currentTarget; btn.classList.add('is-loading');
      var main = sec._getMainItem(); delete main.price;
      var items = [main];
      $$('input[data-ritual-item]:checked', box).forEach(function (c) { items.push({ id: Number(c.value), quantity: 1 }); });
      Cart.add(items).catch(function () {}).finally(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky(sec, form) {
    var bar = $('[data-sticky-atc]'); var target = $('[data-atc]', form); if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { bar.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(target);
    $('[data-sticky-btn]', bar).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
  }

  /* ---------- quick add (cards) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault(); b.classList.add('is-loading');
    Cart.add([{ id: Number(b.getAttribute('data-quick-add')), quantity: 1 }]).catch(function () {}).finally(function () { b.classList.remove('is-loading'); });
  });

  /* ---------- bundle builder ---------- */
  function initBuilder(el) {
    var tiers = JSON.parse(el.getAttribute('data-tiers') || '[]'); // [{min:2,pct:10},...]
    function update() {
      var picks = $$('.pick', el), on = picks.filter(function (p) { return p.querySelector('input').checked; });
      picks.forEach(function (p) { p.classList.toggle('is-on', p.querySelector('input').checked); });
      var sum = on.reduce(function (s, p) { return s + Number(p.querySelector('input').getAttribute('data-price')); }, 0);
      var tier = tiers.filter(function (t) { return on.length >= t.min; }).pop();
      $$('.tier', el).forEach(function (t, i) { t.classList.toggle('is-on', tier && tiers[i] === tier); });
      var after = tier ? Math.round(sum * (100 - tier.pct) / 100) : sum;
      $('[data-builder-total]', el).innerHTML = money(after) + (tier ? ' <s style="font-size:.55em;color:var(--muted)">' + money(sum) + '</s>' : '');
      var next = tiers.find(function (t) { return on.length < t.min; });
      $('[data-builder-msg]', el).textContent = next ? 'Add ' + (next.min - on.length) + ' more to save ' + next.pct + '%' : 'Best value unlocked — ' + tier.pct + '% off applied at checkout';
      var b = $('[data-builder-add]', el); b.disabled = !on.length; b.textContent = on.length ? 'Add ' + on.length + ' to cart' : 'Pick your products';
    }
    el.addEventListener('change', update);
    $('[data-builder-add]', el).addEventListener('click', function (e) {
      var items = $$('.pick input:checked', el).map(function (i) { return { id: Number(i.value), quantity: 1 }; });
      if (!items.length) return; var b = e.currentTarget; b.classList.add('is-loading');
      Cart.add(items).catch(function () {}).finally(function () { b.classList.remove('is-loading'); });
    });
    update();
  }

  /* ---------- related products (recommendations API) ---------- */
  function initRecs(el) {
    var url = el.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var d = document.createElement('div'); d.innerHTML = t; var inner = d.querySelector('[data-recs]');
      if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort]')) { var u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); location.href = u.toString(); }
  });

  document.addEventListener('DOMContentLoaded', function () {
    Drawer.init();
    $$('[data-product-section]').forEach(initProduct);
    $$('[data-builder]').forEach(initBuilder);
    $$('[data-recs-url]').forEach(function (el) { el.setAttribute('data-url', el.getAttribute('data-recs-url')); initRecs(el); });
    if (location.search.indexOf('customer_posted=true') > -1) { var s = $('#md-signup'); if (s) s.scrollIntoView(); }
  });
})();
